import ReturnSeatsContainer from './ReturnSeatsContainer';

export default ReturnSeatsContainer;
